import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import * as DOMPurify from 'dompurify';
class Seperator extends React.Component {
  render() {
    return (
      <Row className={DOMPurify.sanitize(this.props.className)}>
        <Col className="seperator">{this.props.text}</Col>
      </Row>
    );
  }
}

export default Seperator;
